define("discourse/plugins/discourse-ratings/discourse/components/rating-actions", ["exports", "@ember/component"], function (_exports, _component) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = _component.default.extend({
    classNames: "ratings-action-controls"
  });

  _exports.default = _default;
});
define("discourse/plugins/discourse-ratings/discourse/components/rating-destroy", ["exports", "discourse-common/utils/decorators", "../models/rating", "@ember/component"], function (_exports, _decorators, _rating, _component) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _obj;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var _default = _component.default.extend((_dec = (0, _decorators.default)("categoryId", "type"), (_obj = {
    classNames: ["admin-ratings-destroy", "rating-action"],
    destroyDisabled: function destroyDisabled(categoryId, type) {
      return [categoryId, type].any(function (i) {
        return !i;
      });
    },
    actions: {
      destroyRatings: function destroyRatings() {
        var _this = this;

        var data = {
          category_id: this.categoryId
        };
        this.set("startingDestroy", true);

        _rating.default.destroy(this.type, data).then(function (result) {
          if (result.success) {
            _this.set("destroyMessage", "admin.ratings.destroy.started");
          } else {
            _this.set("destroyMessage", "admin.ratings.error.destroy_failed_to_start");
          }
        }).finally(function () {
          return _this.set("startingDestroy", false);
        });
      }
    }
  }, (_applyDecoratedDescriptor(_obj, "destroyDisabled", [_dec], Object.getOwnPropertyDescriptor(_obj, "destroyDisabled"), _obj)), _obj)));

  _exports.default = _default;
});
define("discourse/plugins/discourse-ratings/discourse/components/rating-migrate", ["exports", "discourse-common/utils/decorators", "../models/rating", "@ember/component"], function (_exports, _decorators, _rating, _component) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _obj;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var noneType = "none";

  var _default = _component.default.extend((_dec = (0, _decorators.default)("categoryId", "toType", "fromType"), (_obj = {
    classNames: ["rating-action-controls"],
    migrateDisabled: function migrateDisabled(categoryId, toType, fromType) {
      return [categoryId, toType, fromType].any(function (i) {
        return !i;
      }) || toType !== noneType && fromType !== noneType;
    },
    actions: {
      migrate: function migrate() {
        var _this = this;

        var data = {
          category_id: this.categoryId,
          type: this.fromType,
          new_type: this.toType
        };
        this.set("startingMigration", true);

        _rating.default.migrate(data).then(function (result) {
          if (result.success) {
            _this.set("migrationMessage", "admin.ratings.migrate.started");
          } else {
            _this.set("migrationMessage", "admin.ratings.error.migration_failed_to_start");
          }
        }).finally(function () {
          return _this.set("startingMigration", false);
        });
      }
    }
  }, (_applyDecoratedDescriptor(_obj, "migrateDisabled", [_dec], Object.getOwnPropertyDescriptor(_obj, "migrateDisabled"), _obj)), _obj)));

  _exports.default = _default;
});
define("discourse/plugins/discourse-ratings/discourse/components/rating-object-list", ["exports", "discourse-common/utils/decorators", "../models/rating-object", "@ember/component", "@ember/object/computed", "I18n"], function (_exports, _decorators, _ratingObject, _component, _computed, _I18n) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _obj;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var _default = _component.default.extend((_dec = (0, _decorators.default)("objectType"), _dec2 = (0, _decorators.default)("objectType"), _dec3 = (0, _decorators.default)("objectType"), (_obj = {
    classNameBindings: [":object-types", ":admin-ratings-list", "objectType"],
    hasObjects: (0, _computed.notEmpty)("objects"),
    title: function title(objectType) {
      return _I18n.default.t("admin.ratings.".concat(objectType, ".title"));
    },
    nameLabel: function nameLabel(objectType) {
      return _I18n.default.t("admin.ratings.".concat(objectType, ".name"));
    },
    noneLabel: function noneLabel(objectType) {
      return _I18n.default.t("admin.ratings.".concat(objectType, ".none"));
    },
    actions: {
      newObject: function newObject() {
        this.get("objects").pushObject({
          name: "",
          types: [],
          isNew: true
        });
      },
      addObject: function addObject(obj) {
        var _this = this;

        var data = {
          name: obj.name,
          types: obj.types,
          type: this.objectType
        };
        this.set("loading", true);

        _ratingObject.default.add(data).then(function (result) {
          if (result.success) {
            _this.refresh();
          } else {
            _this.set("loading", false);
          }
        });
      },
      updateObject: function updateObject(obj) {
        var _this2 = this;

        var data = {
          name: obj.name,
          types: obj.types
        };
        this.set("loading", true);

        _ratingObject.default.update(this.objectType, data).then(function (result) {
          if (result.success) {
            _this2.refresh();
          } else {
            _this2.set("loading", false);
          }
        });
      },
      destroyObject: function destroyObject(obj) {
        var _this3 = this;

        if (obj.isNew) {
          this.get("objects").removeObject(obj);
        } else {
          var data = {
            name: obj.name
          };
          this.set("loading", true);

          _ratingObject.default.destroy(this.objectType, data).then(function (result) {
            if (result.success) {
              _this3.refresh();
            } else {
              _this3.set("loading", false);
            }
          });
        }
      }
    }
  }, (_applyDecoratedDescriptor(_obj, "title", [_dec], Object.getOwnPropertyDescriptor(_obj, "title"), _obj), _applyDecoratedDescriptor(_obj, "nameLabel", [_dec2], Object.getOwnPropertyDescriptor(_obj, "nameLabel"), _obj), _applyDecoratedDescriptor(_obj, "noneLabel", [_dec3], Object.getOwnPropertyDescriptor(_obj, "noneLabel"), _obj)), _obj)));

  _exports.default = _default;
});
define("discourse/plugins/discourse-ratings/discourse/components/rating-object", ["exports", "@ember/component", "discourse-common/utils/decorators", "@ember/object/computed", "discourse/models/category", "I18n"], function (_exports, _component, _decorators, _computed, _category, _I18n) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _obj;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var _default = _component.default.extend((_dec = (0, _decorators.default)("error", "object.name", "object.types.[]"), (_obj = {
    classNameBindings: [":rating-object", ":admin-ratings-list-object", "error:hasError"],
    tagName: "tr",
    isCategory: (0, _computed.equal)("objectType", "category"),
    isTag: (0, _computed.equal)("objectType", "tag"),
    error: null,
    didReceiveAttrs: function didReceiveAttrs() {
      var object = this.object;
      this.setProperties({
        currentName: object.name,
        currentTypes: object.types
      });

      if (object.name) {
        if (this.isCategory) {
          var slugPath = object.name.split("/");
          this.set("category", _category.default.findBySlugPath(slugPath));
        }

        if (this.isTag) {
          this.set("tag", object.name);
        }
      }
    },
    saveDisabled: function saveDisabled(error, objectName, objectTypes) {
      return error || !objectName || !objectTypes.length || objectName === this.currentName && JSON.stringify(objectTypes) === JSON.stringify(this.currentTypes);
    },
    actions: {
      updateCategory: function updateCategory(categoryId) {
        var category = _category.default.findById(categoryId);

        var slug = _category.default.slugFor(category);

        var objects = this.objects || [];

        if (objects.every(function (o) {
          return o.name !== slug;
        })) {
          this.setProperties({
            "object.name": slug,
            category: category,
            error: null
          });
        } else {
          this.set("error", _I18n.default.t("admin.ratings.error.object_already_exists", {
            objectType: this.objectType
          }));
        }
      },
      updateTag: function updateTag(tags) {
        var objects = this.objects || [];
        var tag = tags[0];

        if (objects.every(function (o) {
          return o.name !== tag;
        })) {
          this.setProperties({
            "object.name": tag,
            tag: tag,
            error: null
          });
        } else {
          this.set("error", _I18n.default.t("admin.ratings.error.object_already_exists", {
            objectType: this.objectType
          }));
        }
      }
    }
  }, (_applyDecoratedDescriptor(_obj, "saveDisabled", [_dec], Object.getOwnPropertyDescriptor(_obj, "saveDisabled"), _obj)), _obj)));

  _exports.default = _default;
});
define("discourse/plugins/discourse-ratings/discourse/components/rating-star", ["exports", "discourse-common/utils/decorators", "@ember/object/computed", "@ember/component"], function (_exports, _decorators, _computed, _component) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _obj;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var _default = _component.default.extend((_dec = (0, _decorators.default)("rating"), (_obj = {
    tagName: "input",
    disabled: (0, _computed.not)("enabled"),
    attributeBindings: ["value", "checked:checked", "disabled:disabled"],
    willInsertElement: function willInsertElement() {
      this.$().prop("type", "radio");
    },
    didRender: function didRender() {
      // For IE support
      this.element.value = this.value;
    },
    click: function click() {
      this.set("rating", this.$().val());
    },
    checked: function checked(rating) {
      return this.get("value") <= rating;
    }
  }, (_applyDecoratedDescriptor(_obj, "checked", [_dec], Object.getOwnPropertyDescriptor(_obj, "checked"), _obj)), _obj)));

  _exports.default = _default;
});
define("discourse/plugins/discourse-ratings/discourse/components/rating-type-chooser", ["exports", "select-kit/components/multi-select"], function (_exports, _multiSelect) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = _multiSelect.default.extend({
    classNames: ["rating-type-chooser"],
    selectKitOptions: {
      filterable: true
    },
    didReceiveAttrs: function didReceiveAttrs() {
      this._super.apply(this, arguments);

      if (this.types) {
        this.set("value", this.types.split("|"));
      }
    },
    onChange: function onChange(value) {
      this.set("types", value.join("|"));
    }
  });

  _exports.default = _default;
});
define("discourse/plugins/discourse-ratings/discourse/components/rating-type", ["exports", "@ember/component", "@ember/object/computed", "discourse-common/utils/decorators"], function (_exports, _component, _computed, _decorators) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _obj;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var minTypeLength = 2;
  var minNameLength = 2;
  var noneType = "none";

  var _default = _component.default.extend((_dec = (0, _decorators.default)("invalidName", "type.name", "currentName"), (_obj = {
    tagName: "tr",
    classNameBindings: [":rating-type", ":admin-ratings-list-object", "hasError"],
    invalidType: (0, _computed.lt)("type.type.length", minTypeLength),
    invalidName: (0, _computed.lt)("type.name.length", minNameLength),
    addDisabled: (0, _computed.or)("invalidType", "invalidName"),
    noneType: (0, _computed.equal)("type.type", noneType),
    showControls: (0, _computed.not)("noneType"),
    didReceiveAttrs: function didReceiveAttrs() {
      this.set("currentName", this.type.name);
    },
    updateDisabled: function updateDisabled(invalidName, name, currentName) {
      return invalidName || name === currentName;
    }
  }, (_applyDecoratedDescriptor(_obj, "updateDisabled", [_dec], Object.getOwnPropertyDescriptor(_obj, "updateDisabled"), _obj)), _obj)));

  _exports.default = _default;
});
define("discourse/plugins/discourse-ratings/discourse/components/select-rating", ["exports", "@ember/component", "discourse-common/utils/decorators"], function (_exports, _component, _decorators) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _obj;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var _default = _component.default.extend((_dec = (0, _decorators.observes)("rating.include"), (_obj = {
    tagName: "div",
    classNames: ["rating-container"],
    removeOnUncheck: function removeOnUncheck() {
      if (!this.rating.include) {
        this.set("rating.value", 0);
        this.updateRating(this.rating);
      }
    },
    actions: {
      updateRating: function updateRating() {
        this.updateRating(this.rating);
      }
    }
  }, (_applyDecoratedDescriptor(_obj, "removeOnUncheck", [_dec], Object.getOwnPropertyDescriptor(_obj, "removeOnUncheck"), _obj)), _obj)));

  _exports.default = _default;
});
define("discourse/plugins/discourse-ratings/discourse/components/star-rating", ["exports", "@ember/component"], function (_exports, _component) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = _component.default.extend({
    tagName: "span",
    classNames: "star-rating",
    stars: [1, 2, 3, 4, 5],
    enabled: false
  });

  _exports.default = _default;
});
define("discourse/plugins/discourse-ratings/discourse/components/topic-rating-tip", ["exports", "@ember/component", "@ember/runloop"], function (_exports, _component, _runloop) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = _component.default.extend({
    classNames: "topic-rating-tip",
    didInsertElement: function didInsertElement() {
      $(document).on("click", (0, _runloop.bind)(this, this.documentClick));
    },
    willDestroyElement: function willDestroyElement() {
      $(document).off("click", (0, _runloop.bind)(this, this.documentClick));
    },
    documentClick: function documentClick(e) {
      var $element = $(this.element);
      var $target = $(e.target);

      if ($target.closest($element).length < 1 && this._state !== "destroying") {
        this.set("showDetails", false);
      }
    },
    actions: {
      toggleDetails: function toggleDetails() {
        this.toggleProperty("showDetails");
      }
    }
  });

  _exports.default = _default;
});
Ember.TEMPLATES["javascripts/discourse/connectors/composer-fields/composer-controls-rating"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[\"rating\"],\"statements\":[[4,\"if\",[[24,[\"model\",\"showRatings\"]]],null,{\"statements\":[[4,\"each\",[[24,[\"model\",\"ratings\"]]],null,{\"statements\":[[0,\"    \"],[1,[28,\"select-rating\",null,[[\"rating\",\"updateRating\"],[[23,1,[]],[28,\"action\",[[23,0,[]],\"updateRating\"],null]]]],false],[0,\"\\n\"]],\"parameters\":[1]},null]],\"parameters\":[]},null]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/connectors/composer-fields/composer-controls-rating"}});
define("discourse/plugins/discourse-ratings/discourse/connectors/composer-fields/composer-controls-rating", ["exports", "@ember/object"], function (_exports, _object) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    actions: {
      updateRating: function updateRating(rating) {
        var ratings = this.get("model.ratings") || [];
        var index = ratings.findIndex(function (r) {
          return r.type === rating.type;
        });
        (0, _object.set)(ratings[index], "value", rating.value);
        this.set("model.ratings", ratings);
      }
    }
  };
  _exports.default = _default;
});
Ember.TEMPLATES["javascripts/discourse/connectors/topic-category/topic-tip-container"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[4,\"if\",[[24,[\"topic\",\"show_ratings\"]]],null,{\"statements\":[[0,\"  \"],[1,[28,\"topic-rating-tip\",null,[[\"details\"],[\"topic.tip.ratings.details\"]]],false],[0,\"\\n\"]],\"parameters\":[]},null]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/connectors/topic-category/topic-tip-container"}});
define("discourse/plugins/discourse-ratings/discourse/connectors/topic-category/topic-tip-container", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    shouldRender: function shouldRender(_, ctx) {
      return ctx.siteSettings.rating_enabled && ctx.siteSettings.rating_show_topic_tip;
    }
  };
  _exports.default = _default;
});
var __t = requirejs('discourse-common/lib/raw-handlebars').template({"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  "
    + container.escapeExpression((lookupProperty(helpers,"rating-list")||(depth0 && lookupProperty(depth0,"rating-list"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"context.topic.ratings",{"name":"rating-list","hash":{"linkTo":true,"topic":"context.topic"},"hashTypes":{"linkTo":"BooleanLiteral","topic":"PathExpression"},"hashContexts":{"linkTo":depth0,"topic":depth0},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":2,"column":2},"end":{"line":2,"column":71}}}))
    + "\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),"context.topic.show_ratings",{"name":"if","hash":{},"hashTypes":{},"hashContexts":{},"fn":container.program(1, data, 0),"inverse":container.noop,"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":3,"column":7}}})) != null ? stack1 : "");
},"useData":true});;
requirejs('discourse-common/lib/raw-templates').addRawTemplate("javascripts/discourse/connectors/topic-list-after-title/topic-list-rating", __t);
Ember.TEMPLATES["javascripts/discourse/connectors/topic-title/topic-rating-container"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[4,\"if\",[[24,[\"model\",\"show_ratings\"]]],null,{\"statements\":[[0,\"  \"],[1,[28,\"rating-list\",[[24,[\"model\",\"ratings\"]]],[[\"topic\"],[[24,[\"model\"]]]]],false],[0,\"\\n\"]],\"parameters\":[]},null]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/connectors/topic-title/topic-rating-container"}});
define("discourse/plugins/discourse-ratings/discourse/connectors/topic-title/topic-rating-container", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    shouldRender: function shouldRender(_, ctx) {
      return ctx.siteSettings.rating_enabled;
    }
  };
  _exports.default = _default;
});
define("discourse/plugins/discourse-ratings/discourse/controllers/admin-plugins-ratings", ["exports", "@ember/controller", "../models/rating-type", "@ember/object/computed", "I18n"], function (_exports, _controller, _ratingType, _computed, _I18n) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = _controller.default.extend({
    hasTypes: (0, _computed.notEmpty)("ratingTypes"),
    actions: {
      newType: function newType() {
        this.get("ratingTypes").pushObject(_ratingType.default.create({
          isNew: true,
          type: "",
          name: ""
        }));
      },
      addType: function addType(typeObj) {
        var _this = this;

        var data = {
          type: typeObj.type,
          name: typeObj.name
        };
        this.set("loading", true);

        _ratingType.default.add(data).then(function (result) {
          if (result.success) {
            _this.send("refresh");
          } else {
            typeObj.set("hasError", true);

            _this.set("loading", false);
          }
        });
      },
      updateType: function updateType(typeObj) {
        var _this2 = this;

        var data = {
          name: typeObj.name
        };
        this.set("loading", true);

        _ratingType.default.update(typeObj.type, data).then(function (result) {
          if (result.success) {
            _this2.send("refresh");
          } else {
            typeObj.set("hasError", true);

            _this2.set("loading", false);
          }
        });
      },
      destroyType: function destroyType(typeObj) {
        var _this3 = this;

        if (typeObj.isNew) {
          this.get("ratingTypes").removeObject(typeObj);
        } else {
          bootbox.confirm(_I18n.default.t("admin.ratings.type.confirm_destroy"), _I18n.default.t("no_value"), _I18n.default.t("yes_value"), function (result) {
            if (result) {
              _this3.set("loading", true);

              _ratingType.default.destroy(typeObj.type).then(function (response) {
                if (response.success) {
                  _this3.send("refresh");
                } else {
                  typeObj.set("hasError", true);

                  _this3.set("loading", false);
                }
              });
            }
          });
        }
      }
    }
  });

  _exports.default = _default;
});
define("discourse/plugins/discourse-ratings/discourse/helpers/rating-helpers", ["discourse-common/lib/helpers", "../lib/rating-utilities", "handlebars"], function (_helpers, _ratingUtilities, _handlebars) {
  "use strict";

  (0, _helpers.registerUnbound)("rating-list", function (ratings) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return new _handlebars.default.SafeString((0, _ratingUtilities.ratingListHtml)(ratings, opts));
  });
});
define("discourse/plugins/discourse-ratings/discourse/initializers/initialize-ratings", ["exports", "discourse/models/composer", "discourse/models/category", "discourse/lib/plugin-api", "discourse-common/utils/decorators", "@ember/object/computed", "../lib/rating-utilities", "I18n", "handlebars"], function (_exports, _composer, _category, _pluginApi, _decorators, _computed, _ratingUtilities, _I18n, _handlebars) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

  function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

  function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

  function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

  function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

  function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var _default = {
    name: "initialize-ratings",
    initialize: function initialize(container) {
      var siteSettings = container.lookup("site-settings:main");

      if (!siteSettings.rating_enabled) {
        return;
      }

      _composer.default.serializeOnCreate("ratings", "ratingsString");

      _composer.default.serializeOnUpdate("ratings", "ratingsString");

      (0, _pluginApi.withPluginApi)("0.10.0", function (api) {
        var _dec, _dec2, _dec3, _dec4, _dec5, _obj, _dec6, _obj2, _dec7, _obj3, _dec8, _obj4, _dec9, _obj5;

        var currentUser = api.getCurrentUser();
        api.includePostAttributes("ratings");
        api.decorateWidget("poster-name:after", function (helper) {
          var post = helper.getModel();

          if (post && post.topic && post.topic.show_ratings && post.ratings) {
            return helper.rawHtml("".concat(new _handlebars.default.SafeString((0, _ratingUtilities.ratingListHtml)(post.ratings))));
          }
        });
        api.reopenWidget("poster-name", {
          buildClasses: function buildClasses() {
            var post = this.findAncestorModel();
            var classes = [];

            if (post && post.topic && post.topic.show_ratings && post.ratings) {
              classes.push("has-ratings");
            }

            return classes;
          }
        });
        api.modifyClass("model:composer", (_dec = (0, _decorators.default)("editingPostWithRatings", "topicFirstPost", "post.ratings", "allowedRatingTypes.[]", "topic.user_can_rate.[]"), _dec2 = (0, _decorators.default)("ratingTypes", "editingPostWithRatings", "post.ratings"), _dec3 = (0, _decorators.default)("tags", "category"), _dec4 = (0, _decorators.default)("ratings"), _dec5 = (0, _decorators.default)("ratingsToSave"), (_obj = {
          editingPostWithRatings: (0, _computed.and)("editingPost", "post.ratings.length"),
          hasRatingTypes: (0, _computed.notEmpty)("ratingTypes"),
          showRatings: (0, _computed.or)("hasRatingTypes", "editingPostWithRatings"),
          ratingTypes: function ratingTypes(editingPostWithRatings, topicFirstPost, postRatings, allowedRatingTypes, userCanRate) {
            var types = [];

            if (editingPostWithRatings) {
              types.push.apply(types, _toConsumableArray(postRatings.map(function (r) {
                return r.type;
              })));
            }

            if (topicFirstPost && allowedRatingTypes.length) {
              allowedRatingTypes.forEach(function (t) {
                if (types.indexOf(t) === -1) {
                  types.push(t);
                }
              });
            } else if (userCanRate && userCanRate.length) {
              userCanRate.forEach(function (t) {
                if (types.indexOf(t) === -1) {
                  types.push(t);
                }
              });
            }

            return types;
          },
          ratings: function ratings(ratingTypes, editingPostWithRatings, postRatings) {
            var typeNames = this.site.rating_type_names;
            return ratingTypes.map(function (type) {
              var currentRating = (postRatings || []).find(function (r) {
                return r.type === type;
              });
              var value;
              var include;

              if (editingPostWithRatings && currentRating) {
                value = currentRating.value;
                include = currentRating.weight > 0 ? true : false;
              }

              var rating = {
                type: type,
                value: value,
                include: include !== null ? include : true
              };

              if (typeNames && typeNames[type]) {
                rating.typeName = typeNames[type];
              }

              return rating;
            });
          },
          allowedRatingTypes: function allowedRatingTypes(tags, category) {
            var site = this.site;
            var types = [];

            if (category) {
              var categoryTypes = site.category_rating_types[_category.default.slugFor(category)];

              if (categoryTypes) {
                types.push.apply(types, _toConsumableArray(categoryTypes));
              }
            }

            if (tags) {
              var tagTypes = site.tag_rating_types;

              if (tagTypes) {
                tags.forEach(function (t) {
                  if (tagTypes[t]) {
                    types.push.apply(types, _toConsumableArray(tagTypes[t]));
                  }
                });
              }
            }

            return types;
          },
          ratingsToSave: function ratingsToSave(ratings) {
            return ratings.map(function (r) {
              return {
                type: r.type,
                value: r.value,
                weight: r.include ? 1 : 0
              };
            });
          },
          ratingsString: function ratingsString(ratingsToSave) {
            return JSON.stringify(ratingsToSave);
          }
        }, (_applyDecoratedDescriptor(_obj, "ratingTypes", [_dec], Object.getOwnPropertyDescriptor(_obj, "ratingTypes"), _obj), _applyDecoratedDescriptor(_obj, "ratings", [_dec2], Object.getOwnPropertyDescriptor(_obj, "ratings"), _obj), _applyDecoratedDescriptor(_obj, "allowedRatingTypes", [_dec3], Object.getOwnPropertyDescriptor(_obj, "allowedRatingTypes"), _obj), _applyDecoratedDescriptor(_obj, "ratingsToSave", [_dec4], Object.getOwnPropertyDescriptor(_obj, "ratingsToSave"), _obj), _applyDecoratedDescriptor(_obj, "ratingsString", [_dec5], Object.getOwnPropertyDescriptor(_obj, "ratingsString"), _obj)), _obj)));
        api.modifyClass("controller:composer", {
          save: function save() {
            var model = this.model;
            var ratings = model.ratings;
            var showRatings = model.showRatings;

            if (showRatings && ratings.some(function (r) {
              return r.include && !r.value;
            })) {
              return bootbox.alert(_I18n.default.t("composer.select_rating"));
            }

            return this._super();
          }
        });
        api.modifyClass("component:composer-body", (_dec6 = (0, _decorators.observes)("composer.showRatings"), (_obj2 = {
          resizeIfShowRatings: function resizeIfShowRatings() {
            if (this.get("composer.viewOpen")) {
              this.resize();
            }
          }
        }, (_applyDecoratedDescriptor(_obj2, "resizeIfShowRatings", [_dec6], Object.getOwnPropertyDescriptor(_obj2, "resizeIfShowRatings"), _obj2)), _obj2)));
        api.registerCustomPostMessageCallback("ratings", function (controller, data) {
          var model = controller.get("model");
          model.set("ratings", data.ratings);
          model.get("postStream").triggerChangedPost(data.id, data.updated_at).then(function () {
            controller.appEvents.trigger("post-stream:refresh", {
              id: data.id
            });
          });

          if (data.user_id === currentUser.id) {
            model.set("user_can_rate", data.user_can_rate);
          }

          controller.appEvents.trigger("header:update-topic", model);
        });
        api.modifyClass("component:topic-list-item", (_dec7 = (0, _decorators.default)("topic", "lastVisitedTopic", "hasRatings"), (_obj3 = {
          hasRatings: (0, _computed.and)("topic.show_ratings", "topic.ratings"),
          unboundClassNames: function unboundClassNames(topic, lastVisitedTopic, hasRatings) {
            var classes = this._super(topic, lastVisitedTopic) || "";

            if (hasRatings) {
              classes += " has-ratings";
            }

            return classes;
          }
        }, (_applyDecoratedDescriptor(_obj3, "unboundClassNames", [_dec7], Object.getOwnPropertyDescriptor(_obj3, "unboundClassNames"), _obj3)), _obj3)));
        api.modifyClass("component:topic-title", (_dec8 = (0, _decorators.on)("init"), (_obj4 = {
          hasRatings: (0, _computed.alias)("model.show_ratings"),
          editing: (0, _computed.alias)("topicController.editingTopic"),
          hasTags: (0, _computed.notEmpty)("model.tags"),
          showTags: (0, _computed.and)("hasTags", "siteSettings.tagging_enabled"),
          hasFeaturedLink: (0, _computed.notEmpty)("model.featured_link"),
          showFeaturedLink: (0, _computed.and)("hasFeaturedLink", "siteSettings.topic_featured_link_enabled"),
          hasExtra: (0, _computed.or)("showTags", "showFeaturedLink"),
          classNameBindings: ["hasRatings", "editing", "hasExtra"],
          setupController: function setupController() {
            var topicController = container.lookup("controller:topic");
            this.set("topicController", topicController);
          }
        }, (_applyDecoratedDescriptor(_obj4, "setupController", [_dec8], Object.getOwnPropertyDescriptor(_obj4, "setupController"), _obj4)), _obj4)));
        api.modifyClass("component:composer-body", (_dec9 = (0, _decorators.on)("didRender"), (_obj5 = {
          addContainerClass: function addContainerClass() {
            if (!this.element || this.isDestroying || this.isDestroyed) {
              return;
            }

            if (this.composer && this.composer.showRatings) {
              if (!this.element.classList.contains("reply-control-ratings")) {
                this.element.classList.add("reply-control-ratings");
              }
            }
          }
        }, (_applyDecoratedDescriptor(_obj5, "addContainerClass", [_dec9], Object.getOwnPropertyDescriptor(_obj5, "addContainerClass"), _obj5)), _obj5)));
      });
    }
  };
  _exports.default = _default;
});
define("discourse/plugins/discourse-ratings/discourse/lib/rating-utilities", ["exports", "discourse/lib/ajax", "discourse/lib/ajax-error", "I18n"], function (_exports, _ajax, _ajaxError, _I18n) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ratingListHtml = ratingListHtml;
  _exports.request = request;

  var starRatingRaw = function starRatingRaw(rating) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var content = "";

    for (var i = 0; i < 5; i++) {
      var value = i + 1;
      var checked = value <= rating ? "checked" : "";
      var disabled = opts.enabled ? "" : " disabled";
      var star = "";

      if (opts.clickable) {
        star += '<span class="' + checked + disabled + '"></span>';
      } else {
        star += '<input class="' + disabled + '"type="radio" value="' + value + '" ' + checked + disabled + ">";
      }

      star += "<i></i>";
      content = content.concat(star);
    }

    return '<span class="star-rating">' + content + "</span>";
  };

  function ratingHtml(rating) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var html = "";
    var title = "";
    var link = null;
    var name = rating.type_name;

    if (name) {
      html += "<span class=\"rating-type\">".concat(name, "</span>");
      title += "".concat(name, " ");
    }

    var value = Math.round(rating.value * 10) / 10;
    html += starRatingRaw(value);
    title += value;

    if (opts.topic) {
      link = opts.topic.url;
      var siteSettings = Discourse.SiteSettings;

      if (siteSettings.rating_show_numeric_average) {
        html += "<span class=\"rating-value\">(".concat(value, ")</span>");
      }

      if (siteSettings.rating_show_count) {
        var count = rating.count;

        var countLabel = _I18n.default.t("topic.x_rating_count", {
          count: count
        });

        html += "<span class=\"rating-count\">".concat(count, " ").concat(countLabel, "</span>");
        title += " ".concat(count, " ").concat(countLabel);
      }
    }

    if (opts.linkTo && link) {
      return "<a href=\"".concat(link, "\" class=\"rating\" title=\"").concat(title, "\">").concat(html, "</a>");
    } else {
      return "<div class=\"rating\" title=\"".concat(title, "\">").concat(html, "</div>");
    }
  }

  function ratingListHtml(ratings) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (typeof ratings === "string") {
      try {
        ratings = JSON.parse(ratings);
      } catch (e) {
        ratings = null;
      }
    }

    if (!ratings) {
      return "";
    }

    var html = "";
    ratings.forEach(function (rating) {
      var showRating = opts.topic ? rating.count > 0 : rating.weight > 0;

      if (showRating) {
        html += ratingHtml(rating, opts);
      }
    });
    return "<div class=\"rating-list\">".concat(html, "</div>");
  }

  function request(type) {
    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return (0, _ajax.ajax)("/ratings/".concat(path), {
      type: type,
      data: data
    }).catch(_ajaxError.popupAjaxError);
  }
});
define("discourse/plugins/discourse-ratings/discourse/models/rating-object", ["exports", "@ember/object", "../lib/rating-utilities"], function (_exports, _object, _ratingUtilities) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var RatingObject = _object.default.extend();

  RatingObject.reopenClass({
    all: function all(type) {
      return (0, _ratingUtilities.request)("GET", "object/".concat(type));
    },
    add: function add(data) {
      return (0, _ratingUtilities.request)("POST", "object", data);
    },
    update: function update(type, data) {
      return (0, _ratingUtilities.request)("PUT", "object/".concat(type), data);
    },
    destroy: function destroy(type, data) {
      return (0, _ratingUtilities.request)("DELETE", "object/".concat(type), data);
    }
  });
  var _default = RatingObject;
  _exports.default = _default;
});
define("discourse/plugins/discourse-ratings/discourse/models/rating-type", ["exports", "@ember/object", "../lib/rating-utilities"], function (_exports, _object, _ratingUtilities) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var RatingType = _object.default.extend();

  RatingType.reopenClass({
    all: function all() {
      return (0, _ratingUtilities.request)("GET", "rating-type");
    },
    add: function add(data) {
      return (0, _ratingUtilities.request)("POST", "rating-type", data);
    },
    update: function update(type, data) {
      return (0, _ratingUtilities.request)("PUT", "rating-type/".concat(type), data);
    },
    destroy: function destroy(type) {
      return (0, _ratingUtilities.request)("DELETE", "rating-type/".concat(type));
    }
  });
  var _default = RatingType;
  _exports.default = _default;
});
define("discourse/plugins/discourse-ratings/discourse/models/rating", ["exports", "@ember/object", "../lib/rating-utilities"], function (_exports, _object, _ratingUtilities) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var Rating = _object.default.extend();

  Rating.reopenClass({
    destroy: function destroy(type, data) {
      return (0, _ratingUtilities.request)("DELETE", "rating/".concat(type), data);
    },
    migrate: function migrate(data) {
      return (0, _ratingUtilities.request)("POST", "rating/migrate", data);
    }
  });
  var _default = Rating;
  _exports.default = _default;
});
define("discourse/plugins/discourse-ratings/discourse/ratings-route-map", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    resource: "admin.adminPlugins",
    map: function map() {
      this.route("ratings");
    }
  };
  _exports.default = _default;
});
define("discourse/plugins/discourse-ratings/discourse/routes/admin-plugins-ratings", ["exports", "discourse/routes/discourse", "@ember/array", "rsvp", "../models/rating-type", "../models/rating-object", "I18n"], function (_exports, _discourse, _array, _rsvp, _ratingType, _ratingObject, _I18n) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var noneType = "none";

  var _default = _discourse.default.extend({
    model: function model() {
      return _ratingType.default.all();
    },
    afterModel: function afterModel() {
      return (0, _rsvp.all)([this._typesFor("category"), this._typesFor("tag")]);
    },
    setupController: function setupController(controller, model) {
      var ratingTypes = model || [];
      ratingTypes.unshift({
        type: noneType,
        name: _I18n.default.t("admin.ratings.type.none_type"),
        isNone: true
      });
      controller.setProperties({
        ratingTypes: (0, _array.A)(ratingTypes.map(function (t) {
          return _ratingType.default.create(t);
        })),
        categoryTypes: (0, _array.A)(this.categoryTypes),
        tagTypes: (0, _array.A)(this.tagTypes)
      });
    },
    _typesFor: function _typesFor(object) {
      var _this = this;

      return _ratingObject.default.all(object).then(function (result) {
        _this.set("".concat(object, "Types"), result);
      });
    },
    actions: {
      refresh: function refresh() {
        this.refresh();
      }
    }
  });

  _exports.default = _default;
});
Ember.TEMPLATES["javascripts/admin/plugins-ratings"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[\"type\"],\"statements\":[[7,\"div\",true],[10,\"class\",\"types admin-ratings-list\"],[8],[0,\"\\n  \"],[7,\"h3\",true],[8],[1,[28,\"i18n\",[\"admin.ratings.type.title\"],null],false],[9],[0,\"\\n\\n\"],[4,\"if\",[[24,[\"hasTypes\"]]],null,{\"statements\":[[0,\"    \"],[7,\"table\",true],[8],[0,\"\\n      \"],[7,\"thead\",true],[8],[0,\"\\n        \"],[7,\"tr\",true],[8],[0,\"\\n          \"],[7,\"th\",true],[8],[1,[28,\"i18n\",[\"admin.ratings.type.label\"],null],false],[9],[0,\"\\n          \"],[7,\"th\",true],[8],[1,[28,\"i18n\",[\"admin.ratings.type.name\"],null],false],[9],[0,\"\\n        \"],[9],[0,\"\\n      \"],[9],[0,\"\\n      \"],[7,\"tbody\",true],[8],[0,\"\\n\"],[4,\"each\",[[24,[\"ratingTypes\"]]],null,{\"statements\":[[0,\"          \"],[1,[28,\"rating-type\",null,[[\"addType\",\"updateType\",\"destroyType\",\"type\"],[[28,\"action\",[[23,0,[]],\"addType\"],null],[28,\"action\",[[23,0,[]],\"updateType\"],null],[28,\"action\",[[23,0,[]],\"destroyType\"],null],[23,1,[]]]]],false],[0,\"\\n\"]],\"parameters\":[1]},null],[0,\"      \"],[9],[0,\"\\n    \"],[9],[0,\"\\n\"]],\"parameters\":[]},{\"statements\":[[0,\"    \"],[1,[28,\"i18n\",[\"admin.ratings.type.none\"],null],false],[0,\"\\n\"]],\"parameters\":[]}],[0,\"\\n  \"],[7,\"div\",true],[10,\"class\",\"admin-ratings-list-controls\"],[8],[0,\"\\n    \"],[1,[28,\"d-button\",null,[[\"action\",\"label\",\"icon\"],[[28,\"action\",[[23,0,[]],\"newType\"],null],\"admin.ratings.type.new\",\"plus\"]]],false],[0,\"\\n  \"],[9],[0,\"\\n\"],[9],[0,\"\\n\\n\"],[1,[28,\"rating-object-list\",null,[[\"objectType\",\"objects\",\"ratingTypes\",\"refresh\"],[\"category\",[24,[\"categoryTypes\"]],[24,[\"ratingTypes\"]],[28,\"route-action\",[\"refresh\"],null]]]],false],[0,\"\\n\\n\"],[1,[28,\"rating-object-list\",null,[[\"objectType\",\"objects\",\"ratingTypes\",\"refresh\"],[\"tag\",[24,[\"tagTypes\"]],[24,[\"ratingTypes\"]],[28,\"route-action\",[\"refresh\"],null]]]],false],[0,\"\\n\\n\"],[1,[28,\"rating-actions\",null,[[\"ratingTypes\"],[[24,[\"ratingTypes\"]]]]],false]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/admin/plugins-ratings"}});
Ember.TEMPLATES["javascripts/components/rating-actions"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[7,\"div\",true],[10,\"class\",\"admin-ratings-action\"],[8],[0,\"\\n  \"],[7,\"h3\",true],[8],[1,[28,\"i18n\",[\"admin.ratings.migrate.title\"],null],false],[9],[0,\"\\n\\n  \"],[7,\"div\",true],[10,\"class\",\"description\"],[8],[0,\"\\n    \"],[1,[28,\"i18n\",[\"admin.ratings.migrate.description\"],null],false],[0,\"\\n  \"],[9],[0,\"\\n\\n  \"],[7,\"div\",true],[10,\"class\",\"controls\"],[8],[0,\"\\n    \"],[1,[28,\"rating-migrate\",null,[[\"ratingTypes\"],[[24,[\"ratingTypes\"]]]]],false],[0,\"\\n  \"],[9],[0,\"\\n\"],[9],[0,\"\\n\\n\"],[7,\"div\",true],[10,\"class\",\"admin-ratings-action\"],[8],[0,\"\\n  \"],[7,\"h3\",true],[8],[1,[28,\"i18n\",[\"admin.ratings.destroy.title\"],null],false],[9],[0,\"\\n\\n  \"],[7,\"div\",true],[10,\"class\",\"description\"],[8],[0,\"\\n    \"],[1,[28,\"i18n\",[\"admin.ratings.destroy.description\"],null],false],[0,\"\\n  \"],[9],[0,\"\\n\\n  \"],[7,\"div\",true],[10,\"class\",\"controls\"],[8],[0,\"\\n    \"],[1,[28,\"rating-destroy\",null,[[\"ratingTypes\"],[[24,[\"ratingTypes\"]]]]],false],[0,\"\\n  \"],[9],[0,\"\\n\"],[9]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/components/rating-actions"}});
Ember.TEMPLATES["javascripts/components/rating-destroy"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[1,[28,\"category-chooser\",null,[[\"value\",\"onChange\"],[[24,[\"categoryId\"]],[28,\"action\",[[23,0,[]],[28,\"mut\",[[24,[\"categoryId\"]]],null]],null]]]],false],[0,\"\\n\\n\"],[1,[28,\"combo-box\",null,[[\"value\",\"content\",\"valueProperty\",\"onChange\",\"options\"],[[24,[\"type\"]],[24,[\"ratingTypes\"]],\"type\",[28,\"action\",[[23,0,[]],[28,\"mut\",[[24,[\"type\"]]],null]],null],[28,\"hash\",null,[[\"none\"],[\"admin.ratings.type.select\"]]]]]],false],[0,\"\\n\\n\"],[1,[28,\"d-button\",null,[[\"action\",\"label\",\"disabled\"],[\"destroyRatings\",\"admin.ratings.destroy.btn\",[24,[\"destroyDisabled\"]]]]],false],[0,\"\\n\\n\"],[4,\"if\",[[24,[\"startingDestroy\"]]],null,{\"statements\":[[0,\"  \"],[1,[28,\"loading-spinner\",null,[[\"size\"],[\"small\"]]],false],[0,\"\\n\"]],\"parameters\":[]},null],[0,\"\\n\"],[4,\"if\",[[24,[\"destroyMessage\"]]],null,{\"statements\":[[0,\"  \"],[7,\"div\",true],[10,\"class\",\"action-message\"],[8],[0,\"\\n    \"],[1,[28,\"i18n\",[[24,[\"destroyMessage\"]]],null],false],[0,\"\\n  \"],[9],[0,\"\\n\"]],\"parameters\":[]},null]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/components/rating-destroy"}});
Ember.TEMPLATES["javascripts/components/rating-migrate"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[1,[28,\"category-chooser\",null,[[\"value\",\"onChange\"],[[24,[\"categoryId\"]],[28,\"action\",[[23,0,[]],[28,\"mut\",[[24,[\"categoryId\"]]],null]],null]]]],false],[0,\"\\n\\n\"],[1,[28,\"combo-box\",null,[[\"value\",\"content\",\"valueProperty\",\"onChange\",\"options\"],[[24,[\"fromType\"]],[24,[\"ratingTypes\"]],\"type\",[28,\"action\",[[23,0,[]],[28,\"mut\",[[24,[\"fromType\"]]],null]],null],[28,\"hash\",null,[[\"none\"],[\"admin.ratings.type.select\"]]]]]],false],[0,\"\\n\\n\"],[1,[28,\"combo-box\",null,[[\"value\",\"content\",\"valueProperty\",\"onChange\",\"options\"],[[24,[\"toType\"]],[24,[\"ratingTypes\"]],\"type\",[28,\"action\",[[23,0,[]],[28,\"mut\",[[24,[\"toType\"]]],null]],null],[28,\"hash\",null,[[\"none\"],[\"admin.ratings.type.select\"]]]]]],false],[0,\"\\n\\n\"],[1,[28,\"d-button\",null,[[\"action\",\"label\",\"disabled\"],[\"migrate\",\"admin.ratings.migrate.btn\",[24,[\"migrateDisabled\"]]]]],false],[0,\"\\n\\n\"],[4,\"if\",[[24,[\"startingMigration\"]]],null,{\"statements\":[[0,\"  \"],[1,[28,\"loading-spinner\",null,[[\"size\"],[\"small\"]]],false],[0,\"\\n\"]],\"parameters\":[]},null],[0,\"\\n\"],[4,\"if\",[[24,[\"migrationMessage\"]]],null,{\"statements\":[[0,\"  \"],[7,\"div\",true],[10,\"class\",\"action-message\"],[8],[0,\"\\n    \"],[1,[28,\"i18n\",[[24,[\"migrationMessage\"]]],null],false],[0,\"\\n  \"],[9],[0,\"\\n\"]],\"parameters\":[]},null]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/components/rating-migrate"}});
Ember.TEMPLATES["javascripts/components/rating-object-list"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[\"object\"],\"statements\":[[7,\"h3\",true],[8],[1,[22,\"title\"],false],[9],[0,\"\\n\\n\"],[4,\"if\",[[24,[\"loading\"]]],null,{\"statements\":[[0,\"  \"],[1,[22,\"loading-spinner\"],false],[0,\"\\n\"]],\"parameters\":[]},{\"statements\":[[4,\"if\",[[24,[\"hasObjects\"]]],null,{\"statements\":[[0,\"    \"],[7,\"table\",true],[8],[0,\"\\n      \"],[7,\"thead\",true],[8],[0,\"\\n        \"],[7,\"tr\",true],[8],[0,\"\\n          \"],[7,\"th\",true],[8],[1,[22,\"nameLabel\"],false],[9],[0,\"\\n          \"],[7,\"th\",true],[8],[1,[28,\"i18n\",[\"admin.ratings.type.title\"],null],false],[9],[0,\"\\n        \"],[9],[0,\"\\n      \"],[9],[0,\"\\n      \"],[7,\"tbody\",true],[8],[0,\"\\n\"],[4,\"each\",[[24,[\"objects\"]]],null,{\"statements\":[[0,\"          \"],[1,[28,\"rating-object\",null,[[\"object\",\"objects\",\"objectType\",\"ratingTypes\",\"addObject\",\"updateObject\",\"destroyObject\"],[[23,1,[]],[24,[\"objects\"]],[24,[\"objectType\"]],[24,[\"ratingTypes\"]],[28,\"action\",[[23,0,[]],\"addObject\"],null],[28,\"action\",[[23,0,[]],\"updateObject\"],null],[28,\"action\",[[23,0,[]],\"destroyObject\"],null]]]],false],[0,\"\\n\"]],\"parameters\":[1]},null],[0,\"      \"],[9],[0,\"\\n    \"],[9],[0,\"\\n\"]],\"parameters\":[]},{\"statements\":[[0,\"    \"],[1,[22,\"noneLabel\"],false],[0,\"\\n\"]],\"parameters\":[]}]],\"parameters\":[]}],[0,\"\\n\"],[7,\"div\",true],[10,\"class\",\"admin-ratings-list-controls\"],[8],[0,\"\\n  \"],[1,[28,\"d-button\",null,[[\"action\",\"label\",\"icon\"],[[28,\"action\",[[23,0,[]],\"newObject\"],null],\"admin.ratings.type.new\",\"plus\"]]],false],[0,\"\\n\"],[9]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/components/rating-object-list"}});
Ember.TEMPLATES["javascripts/components/rating-object"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[7,\"td\",true],[8],[0,\"\\n\"],[4,\"if\",[[24,[\"object\",\"isNew\"]]],null,{\"statements\":[[4,\"if\",[[24,[\"isCategory\"]]],null,{\"statements\":[[0,\"      \"],[1,[28,\"category-chooser\",null,[[\"value\",\"onChange\"],[[24,[\"category\",\"id\"]],[28,\"action\",[[23,0,[]],\"updateCategory\"],null]]]],false],[0,\"\\n\"]],\"parameters\":[]},null],[4,\"if\",[[24,[\"isTag\"]]],null,{\"statements\":[[0,\"      \"],[1,[28,\"tag-chooser\",null,[[\"tags\",\"everyTag\",\"excludeSynonyms\",\"maximum\",\"onChange\",\"options\"],[[24,[\"tag\"]],true,true,1,[28,\"action\",[[23,0,[]],\"updateTag\"],null],[28,\"hash\",null,[[\"none\"],[\"select_kit.default_header_text\"]]]]]],false],[0,\"\\n\"]],\"parameters\":[]},null]],\"parameters\":[]},{\"statements\":[[4,\"if\",[[24,[\"isCategory\"]]],null,{\"statements\":[[0,\"      \"],[1,[28,\"category-badge\",[[24,[\"category\"]]],null],false],[0,\"\\n\"]],\"parameters\":[]},null],[4,\"if\",[[24,[\"isTag\"]]],null,{\"statements\":[[0,\"      \"],[1,[28,\"discourse-tag\",[[24,[\"tag\"]]],null],false],[0,\"\\n\"]],\"parameters\":[]},null]],\"parameters\":[]}],[9],[0,\"\\n\\n\"],[7,\"td\",true],[8],[0,\"\\n  \"],[1,[28,\"multi-select\",null,[[\"value\",\"content\",\"valueProperty\",\"onChange\"],[[24,[\"object\",\"types\"]],[24,[\"ratingTypes\"]],\"type\",[28,\"action\",[[23,0,[]],[28,\"mut\",[[24,[\"object\",\"types\"]]],null]],null]]]],false],[0,\"\\n\"],[9],[0,\"\\n\\n\"],[7,\"td\",true],[10,\"class\",\"type-controls\"],[8],[0,\"\\n\"],[4,\"if\",[[24,[\"object\",\"isNew\"]]],null,{\"statements\":[[0,\"    \"],[1,[28,\"d-button\",null,[[\"class\",\"action\",\"actionParam\",\"label\",\"icon\",\"disabled\"],[\"btn-primary\",[24,[\"addObject\"]],[24,[\"object\"]],\"admin.ratings.type.add\",\"plus\",[24,[\"saveDisabled\"]]]]],false],[0,\"\\n\"]],\"parameters\":[]},{\"statements\":[[0,\"    \"],[1,[28,\"d-button\",null,[[\"class\",\"action\",\"actionParam\",\"label\",\"icon\",\"disabled\"],[\"btn-primary\",[24,[\"updateObject\"]],[24,[\"object\"]],\"admin.ratings.type.update\",\"save\",[24,[\"saveDisabled\"]]]]],false],[0,\"\\n\"]],\"parameters\":[]}],[0,\"\\n  \"],[1,[28,\"d-button\",null,[[\"action\",\"actionParam\",\"icon\"],[[24,[\"destroyObject\"]],[24,[\"object\"]],\"times\"]]],false],[0,\"\\n\"],[9],[0,\"\\n\\n\"],[4,\"if\",[[24,[\"error\"]]],null,{\"statements\":[[0,\"  \"],[7,\"span\",true],[10,\"class\",\"error\"],[8],[1,[22,\"error\"],false],[9],[0,\"\\n\"]],\"parameters\":[]},null]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/components/rating-object"}});
Ember.TEMPLATES["javascripts/components/rating-type"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[7,\"td\",true],[8],[0,\"\\n\"],[4,\"if\",[[24,[\"type\",\"isNew\"]]],null,{\"statements\":[[0,\"    \"],[1,[28,\"input\",null,[[\"value\",\"placeholder\"],[[24,[\"type\",\"type\"]],[28,\"i18n\",[\"admin.ratings.type.type_placeholder\"],null]]]],false],[0,\"\\n\"]],\"parameters\":[]},{\"statements\":[[0,\"    \"],[1,[24,[\"type\",\"type\"]],false],[0,\"\\n\"]],\"parameters\":[]}],[9],[0,\"\\n\\n\"],[7,\"td\",true],[8],[0,\"\\n\"],[4,\"if\",[[24,[\"type\",\"isNone\"]]],null,{\"statements\":[[0,\"    \"],[1,[28,\"i18n\",[\"admin.ratings.type.none_type_description\"],null],false],[0,\"\\n\"]],\"parameters\":[]},{\"statements\":[[0,\"    \"],[1,[28,\"input\",null,[[\"value\",\"placeholder\"],[[24,[\"type\",\"name\"]],[28,\"i18n\",[\"admin.ratings.type.name_placeholder\"],null]]]],false],[0,\"\\n\"]],\"parameters\":[]}],[9],[0,\"\\n\\n\"],[7,\"td\",true],[10,\"class\",\"type-controls\"],[8],[0,\"\\n\"],[4,\"if\",[[24,[\"showControls\"]]],null,{\"statements\":[[4,\"if\",[[24,[\"type\",\"isNew\"]]],null,{\"statements\":[[0,\"      \"],[1,[28,\"d-button\",null,[[\"class\",\"action\",\"actionParam\",\"label\",\"icon\",\"disabled\"],[\"btn-primary\",[24,[\"addType\"]],[24,[\"type\"]],\"admin.ratings.type.add\",\"plus\",[24,[\"addDisabled\"]]]]],false],[0,\"\\n\"]],\"parameters\":[]},{\"statements\":[[0,\"      \"],[1,[28,\"d-button\",null,[[\"class\",\"action\",\"actionParam\",\"label\",\"icon\",\"disabled\"],[\"btn-primary\",[24,[\"updateType\"]],[24,[\"type\"]],\"admin.ratings.type.update\",\"save\",[24,[\"updateDisabled\"]]]]],false],[0,\"\\n\"]],\"parameters\":[]}],[0,\"\\n    \"],[1,[28,\"d-button\",null,[[\"action\",\"actionParam\",\"icon\"],[[24,[\"destroyType\"]],[24,[\"type\"]],\"times\"]]],false],[0,\"\\n\"]],\"parameters\":[]},null],[9],[0,\"\\n\"]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/components/rating-type"}});
Ember.TEMPLATES["javascripts/components/select-rating"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[1,[28,\"input\",null,[[\"type\",\"checked\",\"class\"],[\"checkbox\",[24,[\"rating\",\"include\"]],\"include-rating\"]]],false],[0,\"\\n\\n\"],[7,\"span\",true],[8],[0,\"\\n\"],[4,\"if\",[[24,[\"rating\",\"typeName\"]]],null,{\"statements\":[[0,\"    \"],[1,[24,[\"rating\",\"typeName\"]],false],[0,\"\\n\"]],\"parameters\":[]},{\"statements\":[[0,\"    \"],[1,[28,\"i18n\",[\"composer.your_rating\"],null],false],[0,\"\\n\"]],\"parameters\":[]}],[9],[0,\"\\n\\n\"],[1,[28,\"star-rating\",null,[[\"enabled\",\"rating\",\"click\"],[[24,[\"rating\",\"include\"]],[24,[\"rating\",\"value\"]],[28,\"action\",[[23,0,[]],\"updateRating\"],null]]]],false],[0,\"\\n\"]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/components/select-rating"}});
Ember.TEMPLATES["javascripts/components/star-rating"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[\"star\"],\"statements\":[[4,\"each\",[[24,[\"stars\"]]],null,{\"statements\":[[0,\"  \"],[1,[28,\"rating-star\",null,[[\"value\",\"rating\",\"enabled\"],[[23,1,[]],[24,[\"rating\"]],[24,[\"enabled\"]]]]],false],[7,\"i\",true],[8],[9],[0,\"\\n\"]],\"parameters\":[1]},null]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/components/star-rating"}});
Ember.TEMPLATES["javascripts/components/topic-rating-tip"] = Ember.HTMLBars.template({"id":null,"block":"{\"symbols\":[],\"statements\":[[7,\"a\",false],[12,\"role\",\"button\"],[3,\"on\",[\"click\",[28,\"action\",[[23,0,[]],\"toggleDetails\"],null]]],[8],[0,\"\\n  \"],[1,[28,\"d-icon\",[\"info-circle\"],null],false],[0,\"\\n\"],[9],[0,\"\\n\"],[4,\"if\",[[24,[\"showDetails\"]]],null,{\"statements\":[[0,\"  \"],[7,\"div\",true],[10,\"class\",\"tip-details\"],[8],[0,\"\\n    \"],[1,[28,\"html-safe\",[[28,\"i18n\",[[24,[\"details\"]]],null]],null],false],[0,\"\\n  \"],[9],[0,\"\\n\"]],\"parameters\":[]},null]],\"hasEval\":false}","meta":{"moduleName":"javascripts/discourse/templates/components/topic-rating-tip"}});
define("discourse/plugins/discourse-ratings/discourse/widgets/rating-star", ["exports", "discourse/widgets/widget"], function (_exports, _widget) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = (0, _widget.createWidget)("rating-star", {
    tagName: "input",
    buildAttributes: function buildAttributes(attrs) {
      var result = {
        type: "radio",
        value: attrs.value
      };

      if (attrs.checked) {
        result["checked"] = true;
      }

      if (attrs.disabled) {
        result["disabled"] = true;
      }

      return result;
    },
    html: function html() {
      return;
    }
  });

  _exports.default = _default;
});
define("discourse/plugins/discourse-ratings/discourse/widgets/star-rating", ["exports", "discourse/widgets/widget", "virtual-dom"], function (_exports, _widget, _virtualDom) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = (0, _widget.createWidget)("star-rating", {
    tagName: "span.star-rating",
    html: function html(attrs) {
      var _this = this;

      var stars = [1, 2, 3, 4, 5];
      var contents = [];
      stars.forEach(function (s) {
        var checked = s <= attrs.rating;
        contents.push(_this.attach("rating-star", {
          value: s,
          checked: checked,
          disabled: attrs.disabled
        }), (0, _virtualDom.h)("i"));
      });
      return contents;
    }
  });

  _exports.default = _default;
});

